package br.com.htms.inspeccaocampo.export

/** Módulos com planilha completa (dados + dashboard). [arquivo] entra no nome do .xlsx. */
enum class PlanilhaModulo(val rotulo: String, val arquivo: String) {
    ATIVOS("Controle de Ativos", "Controle_de_Ativos"),
    OCORRENCIAS("Ocorrências", "Ocorrencias"),
    COLABORADORES("Colaboradores QSMS", "Matriz_Colaboradores"),
    EFETIVO("Efetivo", "Controle_do_Efetivo"),
    FUNCIONARIOS("Funcionários", "Funcionarios_Documentos"),
    RELATORIO_SEGURANCA("Relatório de Segurança", "Relatorio_de_Seguranca")
}
